export const footerContainer = {
  width: "100%",
  backgroundColor: "#FFF",
  padding: "55px 7% 65px",
};
export const footerParagraph = {
  // color: '#7F9BAA',
  color: "#003755",
  fontSize: "0.7500em",
  lineHeight: "18px",
};
export const footerParagraphSmall = {
  // color: '#7F9BAA',
  color: "#003755",
  fontSize: "0.6250em",
  lineHeight: "18px",
};
export const footerHrTag = {
  borderTop: "1px solid #ebe8e4",
  width: "100%",
  overflowX: "visible",
  position: "absolute",
  left: 0,
};
export const FooterReadMore = {
  fontSize: ".750em",
  marginTop: "7px",
  color: "#007BC7",
  cursor: "pointer",
  "&:hover": {
    color: "#009FDA",
  },
};
export const anchorLink = {
  // color: '#009fda !important',
  color: "#007BC7 !important",
  cursor: "pointer",
  textDecoration: "underline !important",
  "&:hover": {
    // color: '#009FDA'
    color: "#007BC7",
  },
};
export const logo = {
  width: "180px",
  height: "42px",
  display: "block",
  objectFit: "contain",
  "@media(min-width: 0px) and (max-width:575px)": {
    width: "125px",
    height: "29px",
    paddingTop: "15px",
  },
  "@media(min-width: 576px) and (max-width:767px)": {
    width: "150px",
    height: "35px",
    paddingTop: "15px",
  },
  "@media(min-width: 768px) and (max-width:991px)": {
    width: "165px",
    height: "39px",
    paddingTop: "10px",
  },
  "@media(min-width: 992px)": {
    width: "180px",
    height: "42px",
    paddingTop: "10px",
  },
};
export const agreementBlock = {
  clear: "both",
  marginTop: "10px",
  display: "flex",
};
export const restrictedLabel = {
  width: "95%",
  float: "left",
  margin: "-5px 0 0 15px",
};
export const link = {
  color: "#009fda !important",
};
export const agreementRadioBlock = {
  marginTop: "25px",
};
